import { useCallback, useEffect, useRef, useState } from 'react';
import { plannerRequest } from './plannerApi';

export default function useIeltsPlanner() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const request = useRef(null);
  const refresh = useCallback(async () => {
    request.current?.abort();
    const controller = new AbortController();
    request.current = controller;
    setLoading(true);
    setError('');
    try {
      const snapshot = await plannerRequest('', { signal: controller.signal });
      if (typeof snapshot?.enabled !== 'boolean') throw new Error('The study planner is unavailable. Please retry.');
      if (!controller.signal.aborted) setData(snapshot);
    } catch (readError) {
      if (!controller.signal.aborted) setError(readError.message || 'Unable to load the study planner.');
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    window.addEventListener('focus', refresh);
    return () => {
      request.current?.abort();
      window.removeEventListener('focus', refresh);
    };
  }, [refresh]);
  return { data, loading, error, refresh };
}
